// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px, ion-content .notifications-block > h2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px, ion-content .notifications-block ion-item ion-label, .notification-settings-block ion-item ion-label {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.notification-btn {
  margin: 0;
  margin-right: 40px;
  color: white;
}
.notification-btn ion-icon {
  font-size: 24px;
}

ion-popover {
  --width: 450px;
  --backdrop-opacity: var(--ion-backdrop-opacity, 0.5);
}

h3 {
  font-family: "Roboto-Regular" !important;
  font-weight: 200 !important;
  font-size: 0.75rem;
}

p {
  font-weight: 400;
  font-size: 0.75rem;
  font-family: "Roboto-Regular";
  padding-top: 2px;
  color: #A7A7AE;
}

.view-more {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding: 16px 0;
}

.back-button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  padding: 16px 16px 0;
  margin: 0;
  background: #EDEEF3;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 20;
}
.back-button-block h2 {
  padding: 0;
  width: fit-content;
}
.back-button-block h2 vl-context-help {
  padding-left: 5px;
}
.back-button-block .list-title {
  margin: 0;
}
.back-button-block .header-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
}
.back-button-block .settings-title {
  margin: 0;
}
.back-button-block .settings-btn {
  width: fit-content;
}
.back-button-block .back-button {
  margin: 0;
  margin-left: -5px;
  color: var(--vl-black-font);
  font-size: 1.1rem;
  width: fit-content;
  --padding-start: 0;
  --padding-end: 0;
  padding-left: 0;
  line-height: 22px;
  font-family: var(--roboto-regular) !important;
}

ion-content {
  --background: #EDEEF3;
}
ion-content .notifications-block > h2 {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  font-size: 1.2rem;
}
ion-content .notifications-block ion-list {
  --min-height: 500px;
}
ion-content .notifications-block ion-list ion-item {
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
}
ion-content .notifications-block ion-list ion-item h2 {
  font-size: 0.9rem;
  font-family: "Roboto-Medium";
  font-weight: 500;
  line-height: 18px;
}
ion-content .notifications-block ion-item {
  position: relative;
  margin: 0;
}
ion-content .notifications-block ion-item ion-label {
  margin: 0;
  text-overflow: clip;
  white-space: normal;
  padding: 8px 16px;
}
ion-content .notifications-block ion-item .arrow-next {
  position: absolute;
  right: 16px;
}
ion-content .notifications-block ion-item .ring {
  padding-left: 16px;
}
ion-content .notifications-block ion-item ion-icon, ion-content .notifications-block ion-item vl-icon.arrow-next {
  position: absolute;
  right: 16px;
  z-index: 100;
  top: 16px;
}
ion-content .notifications-block ion-item ion-icon ::ng-deep svg, ion-content .notifications-block ion-item vl-icon.arrow-next ::ng-deep svg {
  stroke: var(--vl-black-font);
}
ion-content .notifications-block ion-item.read {
  --background: #F8F9FE !important;
  cursor: pointer;
}
ion-content .notifications-block ion-item.unread {
  --background: #ffffff !important;
  cursor: pointer;
}
ion-content .notifications-block ion-item.date-title {
  --background: #EDEEF3;
  border: none;
  font-size: 0.75rem;
  --min-height: 35px !important;
  max-height: 35px !important;
}
ion-content .notifications-block ion-item h5 {
  font-size: 0.75rem;
  font-family: "Roboto-Regular";
  padding-left: 16px;
  color: #A7A7AE;
  margin: 0;
  height: 100%;
  align-items: flex-end;
  display: flex;
  padding-bottom: 3px;
}

.notification-settings-block {
  margin-top: 10px;
  margin-bottom: 30px;
}
.notification-settings-block .back-button-block {
  align-items: flex-start;
  flex-direction: column;
}
.notification-settings-block h3 {
  padding: 16px;
  padding-bottom: 5px;
  margin: 0;
  font-size: 0.9rem;
  color: #A7A7AE;
}
.notification-settings-block ion-item {
  --padding-start: 0;
  --padding-end: 0;
}
.notification-settings-block .option-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.notification-settings-block .option-wrapper .option-description {
  padding-left: 25px;
  margin: 0;
  width: 100%;
}
.notification-settings-block .option-wrapper .title {
  width: 100%;
  padding: 16px 25px 0;
  font-size: 0.9rem;
  font-family: "Roboto-Regular";
  line-height: 18px;
}
.notification-settings-block .option-wrapper ion-item {
  width: 100%;
  padding-left: 30px;
}
.notification-settings-block .option-wrapper ion-item .method-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 12px;
}
.notification-settings-block .option-wrapper ion-item .method-wrapper .method {
  font-size: 14px;
  color: var(--vl-black-font);
}
.notification-settings-block ion-item {
  position: relative;
  margin: 0;
  --background: white !important;
}
.notification-settings-block ion-item:first-child {
  border-top: 1px solid #DDDEE3;
}
.notification-settings-block ion-item ion-label {
  margin: 0;
  text-overflow: clip;
  white-space: normal;
  padding: 8px 16px;
  font-size: 0.9rem;
}
.notification-settings-block ion-item ion-label h3 {
  font-family: "Roboto-Regular" !important;
  font-weight: 200 !important;
  font-size: 0.75rem;
}
.notification-settings-block ion-item ion-label p {
  font-weight: 400;
  font-size: 0.75rem;
  font-family: "Roboto-Regular";
  padding-top: 2px;
  color: #A7A7AE;
}
.notification-settings-block ion-item ion-toggle {
  --ion-color-base: #12B39A !important;
  height: 24px;
  width: 40px;
}

.custom-btn-block {
  display: flex;
  justify-content: center;
}
.custom-btn-block .close-btn {
  --border-color: #262627 !important;
  --color: var(--vl-black-font);
  --background-activated: none;
  --background-hover: none;
  margin: 24px 0;
  width: 180px;
}

.no-notifications-wrapper {
  background: #F8F9FE !important;
  border-top: 1px solid #DDDEE3;
  margin-top: 16px;
}
.no-notifications-wrapper .no-notifications {
  font-size: 16px;
  font-family: "Roboto-Regular";
  color: var(--vl-black-font);
  padding: 30px;
  text-align: center;
}

.settings-btn vl-icon {
  margin-top: 10px;
}

.not-visible {
  opacity: 0;
}

ion-badge {
  background: var(--vl-red);
  font-size: 10px;
  margin-left: -12px;
  margin-bottom: 15px;
}

.mark-all-wrapper {
  font-size: 0.75rem !important;
  color: #A7A7AE;
  font-family: "Roboto-Regular" !important;
  font-size: 14px;
  text-align: end;
  padding-top: 12px;
  padding-bottom: 5px;
}

@media (max-width: 576px) {
  ion-popover {
    --width: 300px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/shared/components/elements/notifications/notifications.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACI,SAAA;EACA,kBAAA;EACA,YAAA;AA0DJ;AAzDI;EACI,eAAA;AA2DR;;AAvDA;EACI,cAAA;EACA,oDAAA;AA0DJ;;AAvDA;EACE,wCAAA;EACA,2BAAA;EACA,kBAAA;AA0DF;;AAvDA;EACE,gBAAA;EACA,kBAAA;EACA,6BDjBe;ECkBf,gBAAA;EACA,cAAA;AA0DF;;AAvDA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AA0DJ;;AAtDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;AAyDF;AAxDE;EACE,UAAA;EACA,kBAAA;AA0DJ;AAzDI;EACE,iBAAA;AA2DN;AAxDE;EACE,SAAA;AA0DJ;AAxDE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;AA0DJ;AAxDE;EACE,SAAA;AA0DJ;AAxDE;EACE,kBAAA;AA0DJ;AAvDE;EACE,SAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;AAyDJ;;AAtDA;EACI,qBAAA;AAyDJ;AAtDI;EAEE,mBDpFW;ECqFX,aAAA;EACA,uBAAA;EACA,iBAAA;AAuDN;AApDI;EACI,mBAAA;AAsDR;AArDQ;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;AAuDZ;AArDY;EACA,iBAAA;EACA,4BDvGI;ECwGJ,gBAAA;EACA,iBAAA;AAuDZ;AAlDI;EACE,kBAAA;EACA,SAAA;AAoDN;AAlDM;EAEE,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAmDR;AAhDM;EACE,kBAAA;EACA,WAAA;AAkDR;AA/CM;EACE,kBAAA;AAiDR;AA9CM;EACE,kBAAA;EACA,WDjIS;ECkIT,YAAA;EACA,SAAA;AAgDR;AA9CQ;EACE,4BAAA;AAgDV;AA5CM;EACE,gCAAA;EACA,eAAA;AA8CR;AA3CM;EACE,gCAAA;EACA,eAAA;AA6CR;AA1CM;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,2BAAA;AA4CR;AAzCM;EACE,kBAAA;EACA,6BDhKS;ECiKT,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AA2CR;;AArCA;EACI,gBAAA;EACA,mBAAA;AAwCJ;AAvCI;EACE,uBAAA;EACA,sBAAA;AAyCN;AAvCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAyCN;AAvCI;EACE,kBAAA;EACA,gBAAA;AAyCN;AAtCI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAwCN;AAvCM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAyCR;AAvCM;EACE,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,6BD9MS;EC+MT,iBAAA;AAyCR;AAvCM;EACE,WAAA;EAYA,kBAAA;AA8BR;AAzCQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA2CV;AA1CU;EACE,eAAA;EACA,2BAAA;AA4CZ;AArCI;EACI,kBAAA;EACA,SAAA;EACA,8BAAA;AAuCR;AArCQ;EACA,6BAAA;AAuCR;AApCQ;EAEA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAqCR;AAnCQ;EACI,wCAAA;EACA,2BAAA;EACA,kBAAA;AAqCZ;AAlCQ;EACI,gBAAA;EACA,kBAAA;EACA,6BD5PK;EC6PL,gBAAA;EACA,cAAA;AAoCZ;AAhCM;EACE,oCAAA;EACA,YAAA;EACA,WAAA;AAkCR;;AA7BA;EACI,aAAA;EACA,uBAAA;AAgCJ;AA/BI;EACI,kCAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,cAAA;EACA,YAAA;AAiCR;;AA7BA;EACE,8BAAA;EACA,6BAAA;EACA,gBAAA;AAgCF;AA/BE;EACE,eAAA;EACA,6BAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;AAiCJ;;AA1BI;EACI,gBAAA;AA6BR;;AAzBA;EACE,UAAA;AA4BF;;AAzBA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AA4BF;;AAzBA;EACE,6BAAA;EACA,cAAA;EACA,wCAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA4BF;;AAzBA;EACI;IACI,yBAAA;EA4BN;AACF","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n.notification-btn {\n    margin: 0;\n    margin-right: 40px;\n    color: white;\n    ion-icon {\n        font-size: 24px;\n    }\n}\n\nion-popover {\n    --width: 450px;\n    --backdrop-opacity: var(--ion-backdrop-opacity, 0.5);\n}\n\nh3 {\n  font-family: $roboto-regular !important;\n  font-weight: 200 !important;\n  font-size: 0.75rem;\n}\n\np {\n  font-weight: 400;\n  font-size: 0.75rem;\n  font-family: $roboto-regular;\n  padding-top: 2px;\n  color: #A7A7AE;\n}\n\n.view-more {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: center;\n    padding: 16px 0;\n}\n\n\n.back-button-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: auto;\n  padding: 16px 16px 0;\n  margin: 0;\n  background: #EDEEF3;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 20;\n  h2 {\n    padding: 0;\n    width: fit-content;\n    vl-context-help {\n      padding-left: 5px;\n    }\n  }\n  .list-title {\n    margin: 0;\n  }\n  .header-wrapper {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n  }\n  .settings-title {\n    margin: 0;\n  }\n  .settings-btn {\n    width: fit-content;\n  }\n  \n  .back-button {\n    margin: 0;\n    margin-left: -5px;\n    color: var(--vl-black-font);\n    font-size: 1.1rem;\n    width: fit-content;\n    --padding-start: 0;\n    --padding-end: 0;\n    padding-left: 0;\n    line-height: 22px;\n    font-family: var(--roboto-regular) !important;\n  }\n}\nion-content {\n    --background: #EDEEF3;\n  .notifications-block {\n\n    & > h2 {\n      @extend .px-16px;\n      margin-bottom: $global-padding;\n      display: flex;\n      justify-content: center;\n      font-size: 1.2rem;\n    }\n\n    ion-list {\n        --min-height: 500px;\n        ion-item {\n            --padding-start: 0;\n            --padding-end: 0;\n            height: auto;\n\n            h2 {\n            font-size: 0.9rem;\n            font-family: $roboto-medium;\n            font-weight: 500;\n            line-height: 18px;\n            }\n        }\n    }\n\n    ion-item {\n      position: relative;\n      margin: 0;\n\n      ion-label {\n        @extend .p-16px;\n        margin: 0;\n        text-overflow: clip;\n        white-space: normal;\n        padding: 8px 16px;\n      }\n\n      .arrow-next {\n        position: absolute;\n        right: 16px;\n      }\n\n      .ring {\n        padding-left: 16px;\n      }\n\n      ion-icon, vl-icon.arrow-next {\n        position: absolute;\n        right: $global-padding;\n        z-index: 100;\n        top: 16px;\n\n        ::ng-deep svg {\n          stroke: var(--vl-black-font);\n        }\n      }\n\n      &.read {\n        --background: #F8F9FE !important;\n        cursor: pointer;\n      }\n\n      &.unread {\n        --background: #ffffff !important;\n        cursor: pointer;\n      }\n\n      &.date-title {\n        --background: #EDEEF3;\n        border: none;\n        font-size: 0.75rem;\n        --min-height: 35px !important;\n        max-height: 35px !important;\n      }\n\n      h5 {\n        font-size: 0.75rem;\n        font-family: $roboto-regular;\n        padding-left: 16px;\n        color: #A7A7AE;\n        margin: 0;\n        height: 100%;\n        align-items: flex-end;\n        display: flex;\n        padding-bottom: 3px;\n      }\n    }\n  }\n}\n\n.notification-settings-block {\n    margin-top: 10px;\n    margin-bottom: 30px;\n    .back-button-block {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n    h3 {\n      padding: 16px;\n      padding-bottom: 5px;\n      margin: 0;\n      font-size:0.9rem;\n      color: #A7A7AE;\n    }\n    ion-item {\n      --padding-start: 0;\n      --padding-end: 0;\n    }\n\n    .option-wrapper {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      .option-description {\n        padding-left: 25px;\n        margin: 0;\n        width: 100%;\n      }\n      .title {\n        width: 100%;\n        padding: 16px 25px 0;\n        font-size: 0.9rem;\n        font-family: $roboto-regular;\n        line-height: 18px;\n      }\n      ion-item {\n        width: 100%;\n        .method-wrapper {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          padding: 0 12px;\n          .method {\n            font-size: 14px;\n            color: var(--vl-black-font);\n          }\n        }\n        padding-left: 30px;\n      }\n    }\n\n    ion-item {\n        position: relative;\n        margin: 0;\n        --background: white !important;\n\n        &:first-child {\n        border-top: 1px solid #DDDEE3;\n        }\n\n        ion-label {\n        @extend .p-16px;\n        margin: 0;\n        text-overflow: clip;\n        white-space: normal;\n        padding: 8px 16px;\n        font-size: 0.9rem;\n\n        h3 {\n            font-family: $roboto-regular !important;\n            font-weight: 200 !important;\n            font-size: 0.75rem;\n        }\n\n        p {\n            font-weight: 400;\n            font-size: 0.75rem;\n            font-family: $roboto-regular;\n            padding-top: 2px;\n            color: #A7A7AE;\n        }\n        }\n\n      ion-toggle {\n        --ion-color-base: #12B39A !important;\n        height: 24px;\n        width: 40px;\n      }\n    }\n}\n\n.custom-btn-block {\n    display: flex;\n    justify-content: center;\n    .close-btn {\n        --border-color: #262627 !important;\n        --color: var(--vl-black-font);\n        --background-activated: none;\n        --background-hover: none;\n        margin: 24px 0;\n        width: 180px;\n    }\n}\n\n.no-notifications-wrapper {\n  background: #F8F9FE !important;\n  border-top: 1px solid #DDDEE3;\n  margin-top: 16px;\n  .no-notifications {\n    font-size: 16px;\n    font-family: \"Roboto-Regular\";\n    color: var(--vl-black-font);\n    padding: 30px;\n    text-align: center;\n  }\n}\n\n\n\n.settings-btn {\n    vl-icon {\n        margin-top: 10px;\n    }\n}\n\n.not-visible {\n  opacity: 0;\n}\n\nion-badge {\n  background: var(--vl-red);\n  font-size: 10px;\n  margin-left: -12px;\n  margin-bottom: 15px;\n}\n\n.mark-all-wrapper {\n  font-size: 0.75rem !important;\n  color: #A7A7AE;\n  font-family: $roboto-regular !important;\n  font-size: 14px;\n  text-align: end;\n  padding-top: 12px;\n  padding-bottom: 5px;\n}\n\n@media (max-width: 576px) {\n    ion-popover {\n        --width: 300px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
